import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { CmsCollection, CmsTaxonomyGeneral, CmsTeaserCard } from '@fcom/core-api';

@Component({
  selector: 'cms-ond-bluewings',
  templateUrl: 'cms-ond-bluewings.component.html',
  styleUrls: ['cms-ond-bluewings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CmsOndBluewingsComponent {
  readonly content = input.required<CmsCollection<CmsTeaserCard>>();

  readonly stories = computed<CmsTeaserCard[]>(() => this.content().items ?? []);

  readonly title = computed<string | undefined>(() => {
    const content = this.content();
    const hasNoTitleTag = (content.subjectTaxonomyTags ?? []).includes(CmsTaxonomyGeneral.NO_TITLE);

    return hasNoTitleTag ? undefined : content.teaserTitle;
  });
}
